import updateExerciseAction from 'modules/training/modules/training-exercises/actions/update'
import getValueReduxUtil from 'modules/redux/utils/get-value'
import { EXERCISE_KEY } from 'modules/training/models/exercise/constants'

function updateEquipmentExerciseAction (instance, value) {
  value = parseInt(value, 10)
  let equipment = getValueReduxUtil(instance, EXERCISE_KEY.EQUIPMENT)
  if (equipment.includes(value)) {
    equipment = equipment.filter(val => val !== value)
  } else {
    equipment = [
      ...equipment,
      value
    ]
  }
  return updateExerciseAction({
    key: EXERCISE_KEY.EQUIPMENT,
    value: equipment,
    instance
  })
}

export default updateEquipmentExerciseAction
